export default __webpack_public_path__ + "static/media/male-solid.9216d7b8.svg";